import { isEmpty } from 'lodash';
import { getCartInfo } from '@/common/service/default-mapper';
import { planUnitMap } from '@/common/product-unit';
import { BILLING_CYCLE, PlanModelInfo, planTypes } from '@/common/constants';

const UsersLimit = { max: 99, min: 1 };

const VisitorManagementPlanMap = {
  [BILLING_CYCLE.MONTHLY]: 'zm_visitor_management_monthly',
  [BILLING_CYCLE.ANNUAL]: 'zm_visitor_management_yearly',
  [BILLING_CYCLE.QUARTERLY]: 'zm_visitor_management_quarterly',
  [BILLING_CYCLE.TWO_YEARS]: 'zm_visitor_management_two_year',
  [BILLING_CYCLE.THREE_YEARS]: 'zm_visitor_management_three_year',
};

export default (planMapJSON) => {
  // switch control
  const visitorManagement = planMapJSON.zvstmgt;
  if (isEmpty(visitorManagement)) {
    return [];
  }
  const result = [];
  Object.entries(VisitorManagementPlanMap).forEach(([billingCycle, planKey]) => {
    const planInfo = visitorManagement[planKey];
    if (!isEmpty(planInfo)) {
      const { plan_code, amount, category, parent_category } = planInfo;
      result.push({
        type: planTypes.VISITOR_MANAGEMENT,
        typeNameKey: 'billing.visitor_management.title',
        planNameKey: 'billing.visitor_management.title',
        standAlone: true,
        unit: planUnitMap.user,
        billing_cycle: billingCycle,
        cartInfo: getCartInfo(),
        dependBasePlanTypeList: [],
        supportCoupon: true,
        plan_code,
        amount,
        category,
        parent_category,
        ...UsersLimit,
        planModel: PlanModelInfo.license
      });
    }
  });
  return result;
};
